import { isValid, parseISO } from "date-fns";

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})/;

const BRAZIL_UTC_OFFSET_ISO = "-03:00";
const BRAZIL_UTC_OFFSET_MS = 3 * 60 * 60 * 1000;

const pad = (value: number): string => String(value).padStart(2, "0");

const toBrazilWallClock = (instant: Date): Date =>
  new Date(instant.getTime() - BRAZIL_UTC_OFFSET_MS);

export const isEndDateAfterStartDate = (
  startDate: string,
  endDate: string,
): boolean => {
  const start = parseISO(startDate);
  const end = parseISO(endDate);
  if (!isValid(start) || !isValid(end)) return false;
  return end.getTime() > start.getTime();
};

export const isValidDateString = (value?: string | null): boolean => {
  if (!value) return false;
  if (DATE_ONLY_PATTERN.test(value)) return true;
  return isValid(parseISO(value));
};

/**
 * Converte uma data (yyyy-MM-dd) no instante ISO do INÍCIO daquele dia no fuso de São Paulo
 * (00:00:00.000 -03:00). Brasil sem horário de verão desde 2019 → offset fixo.
 */
export const toIsoStartOfDay = (value: string): string => {
  const match = DATE_ONLY_PATTERN.exec(value);
  if (!match) {
    const parsed = parseISO(value);
    if (!isValid(parsed)) {
      throw new Error(`Invalid date string: ${value}`);
    }
    return parsed.toISOString();
  }
  const [, year, month, day] = match;
  return new Date(
    `${year}-${month}-${day}T00:00:00.000${BRAZIL_UTC_OFFSET_ISO}`,
  ).toISOString();
};

/**
 * Converte uma data (yyyy-MM-dd) no instante ISO do FIM daquele dia no fuso de São Paulo
 * (23:59:59.999 -03:00) — a vigência cobre o dia escolhido por inteiro.
 */
export const toIsoEndOfDay = (value: string): string => {
  const match = DATE_ONLY_PATTERN.exec(value);
  if (!match) {
    const parsed = parseISO(value);
    if (!isValid(parsed)) {
      throw new Error(`Invalid date string: ${value}`);
    }
    return parsed.toISOString();
  }
  const [, year, month, day] = match;
  return new Date(
    `${year}-${month}-${day}T23:59:59.999${BRAZIL_UTC_OFFSET_ISO}`,
  ).toISOString();
};

export const toDateInputValue = (value?: string | null): string => {
  if (!value) return "";
  const parsed = parseISO(value);
  if (!isValid(parsed)) return "";
  const local = toBrazilWallClock(parsed);
  return `${local.getUTCFullYear()}-${pad(local.getUTCMonth() + 1)}-${pad(local.getUTCDate())}`;
};
